export class ObjectFieldTreeItem {
    key: string;
    label: string;
    data: string;
    icon: string;
    type: string;
    lookupTable: string | null;
    selectable: boolean;
    style: string;
    children: ObjectFieldTreeItem[];
}